import { Link } from "react-router-dom";

export default function Button({ text, href, active }) {
  return (
    <Link
      to={href}
      className={`w-full min-w-fit p-2 flex justify-center items-center text-sm rounded-lg
    ${
      active === true
        ? "bg-zi-gradient-button-blue drop-shadow-md"
        : "bg-zi-bg1-light dark:bg-zi-bg1-dark hocus:ring-1 hocus:ring-inset hocus:ring-zi-border-dark"
    }`}
    >
      <span
        className={`text-nowrap
      ${
        active === true
          ? "text-zi-text-dark drop-shadow-md"
          : "text-zi-text-light dark:text-zi-text-dark"
      }`}
      >
        {text}
      </span>
    </Link>
  );
}
